<template>
  <div class="navbar">
    <div class="navbar-icon-logo">
      <div class="icon-menu" @click="onClickIcon">
        <font-awesome-icon icon="times" v-if="isIconClicked" />
        <font-awesome-icon icon="bars" v-else />
      </div>
      <router-link to="/home">
        <img
          :src="require(`@/assets/logo-navbar.jpg`)"
          alt="image logo home"
          class="logo"
        />
      </router-link>
    </div>
    <SearchBar v-if="!isIconClicked" />
  </div>

  <div class="menu-desktop">
    <ul
      v-for="(menu, index) in menus"
      v-bind:key="index"
      :id="'#menu_' + index"
    >
      <li class="menu">
        <div class="badge">{{ menu.title }}</div>
        <div class="submenu-root">
          <div class="submenu">
            <ul v-if="menu.subMenus">
              <li v-for="subMenu in menu.subMenus" v-bind:key="subMenu.id">
                <card-nav-bar
                  :src="subMenu.src"
                  :title="subMenu.title"
                  :subtitle="subMenu.subtitle"
                  :link="subMenu.link"
                ></card-nav-bar>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div :class="[!this.shouldDisplayMenu ? menuMobile : menuMobileOpen]">
    <ul>
      <li class="menu-mobile-dropdown" v-for="menu in menus" v-bind:key="menu">
        <label
          class="menu-mobile-dropdown-list-title"
          @click="(e) => e.target.classList.toggle('open')"
        >
          {{ menu.title }}
        </label>
        <ul class="menu-mobile-dropdown-list-c">
          <div class="menu-mobile-dropdown-list-item">
            <li v-for="subMenu in menu.subMenus" v-bind:key="subMenu.id">
              <router-link :to="{ path: subMenu.link }" @click="onClickIcon">{{
                subMenu.title
              }}</router-link>
            </li>
          </div>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import CardNavBar from "../Cards/CardNavBar.vue";
import SearchBar from "../SearchBar.vue";

export default {
  name: "NavBar",
  props: ["menus"],
  components: {
    CardNavBar,
    SearchBar,
  },
  data() {
    return {
      isIconClicked: false,
      smallScreen: false,
      menuMobile: "menu-mobile",
      menuMobileOpen: "menu-mobile-open",
    };
  },
  computed: {
    shouldDisplayMenu() {
      return this.isIconClicked && this.smallScreen;
    },
  },
  methods: {
    onClickIcon() {
      this.isIconClicked = !this.isIconClicked;
      this.$emit("iconClicked", this.isIconClicked);
    },
    handleResize() {
      this.smallScreen = window.matchMedia("(max-width: 768px)").matches
        ? true
        : false;
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss">
.navbar {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding-bottom: $spacing-small;

  @media (min-width: $constraint-width-small) {
    align-items: center;
    display: flex;
    flex-direction: row;
  }
}
.navbar-icon-logo {
  display: flex;
  gap: 1.2rem;
}
.icon-menu {
  cursor: pointer;
  display: none;
  font-size: $font-size-large;
  width: 1rem;
  @media screen and (max-width: $breakpoint-medium) {
    display: block;
  }
}
.logo {
  margin-right: 2rem;
  @media screen and (max-width: $breakpoint-medium) {
    width: 5rem;
  }
}
.menu-desktop {
  @media screen and (max-width: $breakpoint-medium) {
    display: none;
  }
  display: flex;
}
.menu-desktop > ul {
  margin-bottom: 0;
}
.menu {
  cursor: pointer;
  padding: 0;
  position: relative;
  margin: 0;
}
.menu:hover .submenu {
  opacity: 1;
  transition: visibility 200ms linear, opacity 150ms linear;
  visibility: visible;
  .badge {
    background: $color-primary;
    border-radius: 10px;
    color: $color-secondary;
    display: inline-block;
    padding: 8px 10px;
  }
}
.menu:hover .badge {
  background: $color-primary;
  color: $color-secondary;
  border-radius: 10px;
  display: inline-block;
  padding: 8px 10px;
}
.menu ul {
  width: 400px;
  padding: 10px 0;
  border-radius: 12px;
  background: #fff;
}
.menu ul li {
  background: #ffffff;
  margin: 0;
}
.submenu-root {
  padding-top: 10px;
}
.submenu {
  border-radius: 12px;
  box-shadow: 0px 10px 70px rgba(0, 0, 0, 0.15);
  display: flex;
  left: -20px;
  opacity: 0;
  position: absolute;
  visibility: hidden;
  z-index: 1;
}
.badge {
  font-size: $font-size-normal;
  font-weight: 500;
  padding: 8px 10px;
}
.menu-mobile {
  display: none;
  li {
    margin: 0;
  }
}
.menu-mobile-open {
  margin: -$spacing-small;
  display: block;
  position: absolute;
  z-index: 10;
  width: 100%;
  height: calc(100vh - 50px);
  background: #fff;
  overflow-y: auto;
  box-shadow: 0px 20px 35px rgba(13, 12, 34, 0.05);
  padding: $spacing-small $spacing-small 120px;
  overflow-x: hidden;
}

.menu-mobile-dropdown {
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.menu-mobile-dropdown input:checked + label::after {
  transform: rotate(180deg);
}
.menu-mobile-dropdown-list-title {
  cursor: pointer;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  color: $color-secondary;
  font-size: 18px;
  font-weight: 600;
  &::after {
    content: url('data:image/svg+xml; utf8, <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" /> </svg>');
    position: absolute;
    right: 0;
    width: 16px;
    height: 16px;
    transition: transform 200ms ease-out, -webkit-transform 200ms ease-out;
    margin-right: 16px;
    transition: -webkit-transform 200ms ease-out;
    transition: transform 200ms ease-out;
    transition: transform 200ms ease-out, -webkit-transform 200ms ease-out;
  }
}
.menu-mobile-dropdown-list-title.open {
  &::after {
    transform: rotate(180deg);
  }
}
.menu-mobile-dropdown-list-title.open + ul {
  max-height: 600px;
  transition: max-height 200ms cubic-bezier(1, 0, 1, 0);
}
.menu-mobile-dropdown-list-c {
  position: relative;
  height: auto;
  max-height: 0px;
  overflow: hidden;
  transition: max-height 200ms cubic-bezier(0, 1, 0, 1);
}
.menu-mobile-dropdown-list-item {
  margin-top: 0.7rem;
  margin-bottom: 0.7rem;
  padding-left: 32px;
  border-left: 2px solid $color-primary;
  line-height: 28px;
  a:hover {
    color: $color-primary;
  }
}
</style>
